import React from 'react';
import { InternalLink } from '../form-elements/Link';

function ProductListFooter() {
    return (
        <div className="uk-flex uk-flex-center uk-flex-middle">
            <div>*inkl. MwSt., zzgl. etwaiger&nbsp;</div>
            <InternalLink to="/versandkosten" modifier="text" hideArrow className="" ariaLabel="Informationen zu Versandkosten">
             <u>Versandkosten</u>
            </InternalLink>
        </div>
    );
}

export default ProductListFooter;
